export default __webpack_public_path__ + "static/media/miscellaneous-v2.d5dbce19.svg";